import { View, Text, TouchableOpacity, Modal, Image } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import Ionicons from "@expo/vector-icons/Ionicons";
import {
  useDeviceSize,
  CreateResponsiveStyle,
  DEVICE_SIZES,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { s } from "react-native-size-matters";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppScreens } from "../../Utility/AppScreens";
import { ActivityIndicator } from "react-native-paper";

export const enum enumPurchaseSuccess {
  purchaseSuccess = "purchaseSuccess",
  saleSuccess = "saleSuccess",
}

const PurchaseSuccess = (props, route) => {
  const routeData = route.params;
  const navigation = useNavigation();
  const {
    showModal = false,
    responseData,
    setShowModal,
    checkScreen = enumPurchaseSuccess.purchaseSuccess,
    tokenData = "",
    showLoader = false,
  } = props;

  const onCloseClick = () => {
    setShowModal(false);
  };
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  useEffect(() => {
    console.log("responseData: ", responseData);
  }, []);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View
        style={[
          styles.container,
          { justifyContent: "center", alignItems: "center" },
        ]}
      >
        <View
          style={[
            styles.mainView,
            { borderWidth: 1, borderColor: AppColors.grayColor_565656 },
          ]}
        >
          <View
            style={{
              flexDirection: "row",
              paddingTop: 20,
              justifyContent: "center",
            }}
          >
            <Text style={[AppFontStyle.BOLD_ANYBODY_32, { flex: 1 }]}>
              {checkScreen === enumPurchaseSuccess.purchaseSuccess
                ? "Purchase successful"
                : "Sale successful"}
            </Text>
            <View style={styles.closeViewStyle}>
              <Ionicons
                name="close"
                size={18}
                color={AppColors.white}
                onPress={onCloseClick}
              />
            </View>
          </View>

          <View
            style={{
              height: 2,
              marginTop: 20,
              backgroundColor: AppColors.appGrayColor_1C1C1C,
              width: "100%",
            }}
          />

          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              { paddingTop: 23, paddingVertical: 15, color: AppColors.white },
            ]}
          >
            {checkScreen === enumPurchaseSuccess.purchaseSuccess
              ? "Your tokens are now Increased"
              : "You have successfully sold your belts"}
          </Text>
          {/* You have successfully sold your belts */}
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_20,
              { paddingTop: 35, paddingVertical: 15, color: AppColors.white },
            ]}
          >
            {checkScreen === enumPurchaseSuccess.purchaseSuccess
              ? "Your Tokens"
              : "You will receive"}
          </Text>
          <View style={styles.codeViewStyle}>
            {showLoader ? (
              <ActivityIndicator color={AppColors.white} />
            ) : (
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_24,
                  { color: AppColors.white },
                ]}
              >
                {/* 5555 */}
                {checkScreen === enumPurchaseSuccess.purchaseSuccess
                  ? tokenData === ""
                    ? "Your Tokens"
                    : tokenData
                  : `${responseData?.amount || 0}`}
              </Text>
            )}
          </View>

          {/* Bottom Buttons */}
          <View style={styles.bottomButtonBGView}>
            {/* View transaction history */}
            <TouchableOpacity
              style={{
                height: 40,
                paddingHorizontal: 15,
                borderColor: AppColors.appViolentColor_6D08C3,
                borderWidth: 1,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 10,
                flex: 1,
              }}
              onPress={() => {
                navigateToScreen(navigation, AppScreens.ViewTrasactionHistory);
                onCloseClick();
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  { color: AppColors.white, textAlign: "center" },
                ]}
              >
                View transaction history
              </Text>
            </TouchableOpacity>

            {/* Send receipt via email */}
            <TouchableOpacity
              style={{
                height: 40,
                paddingHorizontal: 15,
                backgroundColor: AppColors.appViolentColor_6D08C3,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 10,
                flex: 1,
              }}
              onPress={() => {
                console.log("Send receipt via email: ", checkScreen);
                onCloseClick();
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  { color: AppColors.white, textAlign: "center" },
                ]}
              >
                Send receipt via email
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default PurchaseSuccess;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
    },
    mainView: {
      width: 586,
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: 40,
      paddingVertical: 20,
      margin: 30,
      alignSelf: "center",
      borderRadius: 12,
    },
    closeViewStyle: {
      height: 30,
      width: 30,
      justifyContent: "center",
      alignItems: "center",
      borderWidth: 1,
      borderRadius: 6,
      borderColor: AppColors.grayColor_565656,
    },
    codeViewStyle: {
      height: 130,
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      paddingVertical: 15,
      marginTop: 5,
      marginBottom: 35,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 6,
    },
    bottomButtonBGView: {
      height: 50,
      justifyContent: "flex-end",
      flexDirection: "row",
      gap: 15,
      marginVertical: 20,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "60%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      closeViewStyle: {
        height: 30,
        width: 30,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderRadius: 6,
        borderColor: AppColors.grayColor_565656,
      },
      codeViewStyle: {
        height: 130,
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingVertical: 15,
        marginTop: 5,
        marginBottom: 35,
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 6,
      },
      bottomButtonBGView: {
        height: 50,
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 15,
        marginVertical: 20,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "60%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      closeViewStyle: {
        height: 30,
        width: 30,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderRadius: 6,
        borderColor: AppColors.grayColor_565656,
      },
      codeViewStyle: {
        height: 130,
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingVertical: 15,
        marginTop: 5,
        marginBottom: 35,
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 6,
      },
      bottomButtonBGView: {
        height: 50,
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 15,
        marginVertical: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "70%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      closeViewStyle: {
        height: 30,
        width: 30,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderRadius: 6,
        borderColor: AppColors.grayColor_565656,
      },
      codeViewStyle: {
        height: 130,
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingVertical: 15,
        marginTop: 5,
        marginBottom: 35,
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 6,
      },
      bottomButtonBGView: {
        height: 50,
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 15,
        marginVertical: 20,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 16,
        margin: 16,
        alignSelf: "center",
        borderRadius: 12,
      },
      closeViewStyle: {
        height: 30,
        width: 30,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderRadius: 6,
        borderColor: AppColors.grayColor_565656,
      },
      codeViewStyle: {
        height: 130,
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingVertical: 15,
        marginTop: 5,
        marginBottom: 35,
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 6,
      },
      bottomButtonBGView: {
        height: 50,
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 15,
        marginVertical: 20,
      },
    },
  }
);
